import { render, staticRenderFns } from "./HavePensions.vue?vue&type=template&id=493593ac&"
import script from "./HavePensions.vue?vue&type=script&lang=js&"
export * from "./HavePensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports